// @/api/base.js

export default {
  SERVER_OPTIONS: {
    northwest: {
      name: "服务器1",
      // webUrl: "https://www.dibox.com.cn/cmmu",
      // webUrl: "http://8.160.185.107:10046/smartnecklace-mqtt",
      webUrl: "https://www.chip-nova.cn/nw/cmmu",
    },
    main: {
      name: "服务器2",
      webUrl: "https://www.chip-nova.cn/cmmu",
    },
    dev: {
      name: "本地服务器",
      webUrl: "http://localhost:10032",
    },
  },

  currentServer: null,

  init() {
    const savedKey = localStorage.getItem("selectedServer");

    this.currentServer =
      this.SERVER_OPTIONS[savedKey] || this.SERVER_OPTIONS.northwest;
  },

  getUsrBaseUrl() {
    if (!this.currentServer) {
      return this.SERVER_OPTIONS.northwest.webUrl;
    }
    return this.currentServer.webUrl;
  },

  setServer(key) {
    if (this.SERVER_OPTIONS[key]) {
      this.currentServer = this.SERVER_OPTIONS[key];
      localStorage.setItem("selectedServer", key);
    } else {
      console.warn(`无效的服务器选项: ${key}`);
    }
  },
};
